import { useEffect, useState } from "react";
import AppRoutes from "./navigation";
import { useAtom, useSetAtom } from "jotai";
import { generalDataAtom, loginStatusAtom, userAtom } from "./atoms";
import apiAgent from "./api/apiAgent";
import { Loader } from "./components/Loader";
import { ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import { Slide } from "react-toastify";
import { mergeClass } from "./utils";
import { tMsg } from "./components/ToastNotifications";
import _ from "lodash";

const contextClass = {
  success: "bg-successGreen",
  error: "bg-warningRed",
  info: "bg-infoBlue",
  warning: "bg-warningOrange",
  default: "bg-indigo-600",
  dark: "bg-white-600 font-gray-300",
};

function App() {
  const [isValidating, setIsValidating] = useState<boolean>(true);
  const [generalDataLoaded, setGeneralDataLoaded] = useState<boolean>(false);
  const setLoginStatus = useSetAtom(loginStatusAtom);
  const setGeneralData = useSetAtom(generalDataAtom);
  const setUser = useSetAtom(userAtom);

  useEffect(() => {
    fetchGeneralData();
    checkValidate();
  }, []);

  const checkValidate = async () => {
    try {
      const validateResponse = await apiAgent.Auth.validate();
      if (validateResponse.status === 200) {
        setLoginStatus(true);
        setUser(validateResponse.data || null);
      } else if (validateResponse.status === 401) {
        setLoginStatus(false);
        throw "Not logged in";
      }
    } catch (err) {
      console.log(err);
      setLoginStatus(false);
    } finally {
      setIsValidating(false);
    }
  };

  const fetchGeneralData = async () => {
    try {
      const response = await apiAgent.General.get();
      if (response.status === 200) {
        const data = response.data;
        setGeneralData(data);
        setGeneralDataLoaded(true);
        if (_.isString(data.maintenance_info)) {
          tMsg.info(data.maintenance_info, false);
        }
      }
    } catch (err) {
      console.log("Could not set general data", err);
      setGeneralDataLoaded(true);
    }
  };

  if (isValidating)
    return (
      <div className="w-full h-full grid content-center">
        <Loader />
      </div>
    );

  return (
    <>
      <AppRoutes />
      <ToastContainer
        toastClassName={(props) =>
          mergeClass(
            contextClass[props?.type || "default"],
            "relative flex p-3 rounded mb-2 overflow-hidden justify-between cursor-pointer"
          )
        }
        theme="colored"
        transition={Slide}
        position="bottom-right"
      />
    </>
  );
}

export default App;
